import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

const LANGUAGES = [
  { code: 'ja', flag: '🇯🇵', label: '日本語' },
  { code: 'en', flag: '🇺🇸', label: 'English' },
] as const;

/** Compact JA/EN switch for the public auth pages (persists via i18next detector). */
export function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.startsWith('en') ? 'en' : 'ja';

  return (
    <div
      role="group"
      aria-label={t('common.language')}
      className="inline-flex items-center rounded-full border border-border bg-card/60 p-0.5 text-xs backdrop-blur"
    >
      {LANGUAGES.map(({ code, flag, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => i18n.changeLanguage(code)}
          aria-pressed={current === code}
          aria-label={label}
          title={label}
          lang={code}
          className={cn(
            'grid h-7 w-9 place-items-center rounded-full text-base leading-none transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 motion-reduce:transition-none',
            current === code
              ? 'bg-primary/15 ring-1 ring-primary/40'
              : 'opacity-55 grayscale hover:opacity-100 hover:grayscale-0',
          )}
        >
          <span aria-hidden="true">{flag}</span>
        </button>
      ))}
    </div>
  );
}
